// /components/DietAssessment/components/ProgressDisplay.js

import { Box, LinearProgress, Typography } from '@mui/material';
import React from 'react';

export const ProgressDisplay = ({ progress }) => {
  const completedSteps = progress.filter((step) => step.complete).length;
  const totalSteps = progress.length;
  const progressPercent = (completedSteps / totalSteps) * 100;

  return (
    <Box sx={{ mb: 2, textAlign: 'center' }}>
      {/*<Typography variant="subtitle1">
        Progress: {completedSteps} / {totalSteps}
      </Typography>*/}
      <LinearProgress
        variant="determinate"
        value={progressPercent}
      />
    </Box>
  );
};
